import { styled } from "@linaria/react";

import Text, { TextSize, TextVariant } from "@gx/dls/text/Text";
import { withTheme, type PropsWithTheme } from "@gx/dls/theme";

import {
  DROPZONE_TABLE_VIEW_COLUMN_TO_LABEL_MAP,
  DROPZONE_TABLE_VIEW_COLUMNS,
} from "@/pages/sources/components/dropzone/constants";
import DropzoneWidgetTableCell from "@/pages/sources/components/dropzone/DropzoneWidgetTableCell";
import { DropzoneTableViewColumn } from "@/pages/sources/components/dropzone/types";

const DropzoneWidgetTableHeaderWrapper = withTheme(styled.div<PropsWithTheme>`
  display: flex;
  align-items: center;
  width: 100%;
  height: 26px;
  padding: 0 8px;
  background-color: ${({ theme }) => theme.color.background.tertiary};
`);

const DropzoneWidgetTableHeader = () => {
  const renderColumn = (column: DropzoneTableViewColumn, index: number) => {
    return (
      <DropzoneWidgetTableCell column={column} key={index}>
        <Text size={TextSize.BODY_SM} variant={TextVariant.SECONDARY}>
          {DROPZONE_TABLE_VIEW_COLUMN_TO_LABEL_MAP[column]}
        </Text>
      </DropzoneWidgetTableCell>
    );
  };

  return (
    <DropzoneWidgetTableHeaderWrapper>
      {DROPZONE_TABLE_VIEW_COLUMNS.map((column, index) => renderColumn(column, index))}
    </DropzoneWidgetTableHeaderWrapper>
  );
};

export default DropzoneWidgetTableHeader;
